module.exports = __webpack_public_path__ + "img/gift.9f1822b9.svg";